var ipp = document.querySelectorAll(".ipp");
ipp.forEach((item) => {
  var hqip = item.querySelector(".ip");
  var ipCon = item.querySelector(".ip-con");
  var ipWc = item.querySelectorAll(".ip-wc");
  var ipName = item.querySelectorAll(".ip-name");
  var ipSpan = item.querySelectorAll('.ip-span');
  var flages = true;

  hqip.onclick = function (e) {
    e.stopPropagation()
    if (flages) {
      ipCon.style.display = "block"
      ipWc.forEach((item) => {
        var aLink = item.querySelector('a');
        aLink.setAttribute('target', '_self');
      })
      
      setTimeout(() => {
        ipCon.style.opacity = "1"
        flages = false
      })
    } else {
      ipCon.style.opacity = "0"
      setTimeout(() => {
        ipCon.style.display = "none"
        flages = true
      }, 300)

    }
  }
})

document.body.onclick = function () {
  ipp.forEach((item) => {
    var ipCon = item.querySelector(".ip-con");
    ipCon.style.opacity = "0";
    setTimeout(() => {
      ipCon.style.display = "none"
      flages = true
    }, 300)
  })
}